import { AppRouteProps } from "@harea/component";
import React from "react";

const DetailsContainer = React.lazy(() => import('./containers/AboutUserDetailsContainer'))

export const DetailsRoutes: Array<AppRouteProps> = [
    {
        path: '',
        title: "Generic.UserAccount.About.title",
        element: <DetailsContainer />
    }
]
